



import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./assets/styles/style.scss";
import Login from "./pages/Login";
import Otp from "./pages/Otp";
import Voucher from "./pages/Voucher";

import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import { Toaster } from "react-hot-toast";
import OtpRoute from "./routes/OtpRoute";
import NotFound from "./pages/NotFound";
import AutoLogout from "./utils/AutoLogout";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    localStorage.clear()

    // Right Click Disable
    const disableRightClick = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", disableRightClick);


    // DevTools Disable
    const disableDevTools = (e) => {

      if (e.key === "F12") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
      }

      if (e.ctrlKey && e.key === "U") {
        e.preventDefault();
      }

    };

    document.addEventListener("keydown", disableDevTools);

    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableDevTools);
    };

  }, []);

  return (
    <>
      <BrowserRouter>
        <AutoLogout />
        <Routes>

          <Route
            path="/"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route path="/otp" element={<OtpRoute><Otp /></ OtpRoute>} />

          <Route
            path="/voucher"
            element={
              <ProtectedRoute>
                <Voucher />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" /> </>

  );
}

export default App;